/* eslint-disable react/prop-types */
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
// import PropTypes from "prop-types";
import { alertMessage } from "./styles";

const Alert = React.forwardRef(function Alert(props, ref) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Toast({ open, severity, message, handleClose }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={2000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={severity} sx={alertMessage}>
        {message}
      </Alert>
    </Snackbar>
  );
}

// const propTypes = {
//   open: PropTypes.bool.isRequired,
//   severity: PropTypes.string.isRequired,
//   message: PropTypes.string.isRequired,
//   handleClose: PropTypes.func.isRequired,
// };

// Toast.propTypes = propTypes;

export default Toast;
